import {
  PricingPackResponse,
  PricingResponse,
} from '../../../services/pricing';
import { pricingToElement } from './pricingToElement';

export function ServiceToElement(
  offer: PricingPackResponse,
  pricing: PricingResponse,
  investamount: number,
  schedule: any,
  installementamount: number,
  cteidparent: number,
  servbasisamount: number,
  ctemileage?: number,
  ctepriidexceed?: number
) {
  const elem = pricingToElement(
    offer,
    pricing,
    investamount,
    0,
    0,
    0,
    0,
    cteidparent
  );

  // //
  return {
    ...elem,
    // pricing:pricing.pricing,
    cteinstallmentamount: installementamount,
    cteperiodicity: pricing.periodicity,
    cteduration:
      pricing.serviceResponse.servduration === 'FREE'
        ? pricing.serviceResponse.servdurationdefault
        : pricing.durationdefault,
    ctepriidexceed: ctepriidexceed ?? 0,
    ctemileage: ctemileage ?? 0,    
    conElemSchedules: schedule,
    conElemSteps: pricing.serviceStepList ?? [],
    servfixedamount: pricing.servfixedamount,
    servpercentage: pricing.servpercentage,
    servbasis: servbasisamount,
    additionalcostaftermargin:
      pricing.serviceResponse.additionalcostaftermargin,
    marginoncalulatedamount: pricing.serviceResponse.marginoncalulatedamount,
    servusecoverage:pricing.serviceResponse.servusecoverage,
    servusedeductionamount:pricing.serviceResponse.servusedeductionamount,
    servusedeductionpercenrage:pricing.serviceResponse.servusedeductionpercenrage,
    servusefrequency:pricing.serviceResponse.servusefrequency,
    servusemaxamount:pricing.serviceResponse.servusemaxamount,
    servuseminamount:pricing.serviceResponse.servuseminamount,
    servuseqty:pricing.serviceResponse.servuseqty,
    servuseunit:pricing.serviceResponse.servuseunit,
    servdescription:pricing.serviceResponse.servdescription,
  };
}
